import React, { useEffect, useState } from "react";
import { DataGrid, GridMoreVertIcon, gridClasses } from "@mui/x-data-grid";
import { HiOutlineEye } from "react-icons/hi2";
import { CiEdit } from "react-icons/ci";
import { GoTrash } from "react-icons/go";
import { RxPlus } from "react-icons/rx";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Box,
  Button,
  MenuItem,
  Popover,
  styled,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import "./Nutrients.scss";
import { HttpService } from "../../../service/HttpService";
import FullScreenLoader from "../../../components/Loader/FullScreenLoader";
import AddEditNutrients from "../../../components/Fertigation/AddEditNutrients";
import DeleteModal from "../../../components/Model/DeleteModal";
import { useAuth } from "../../../context/AuthProvider";
import { Encryption } from "../../../Mixin/EncryptDecryptId";
import { useFilter } from "../../../context/FilterProvider";
import { TbFilterEdit } from "react-icons/tb";
import DateTimeModal from "../../Schedule/ScheduleListAdd/DateTimeModal";
import dayjs from "dayjs";

const Nutrients = () => {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [open, setOpen] = useState(false);  
  const [id, setId] = useState();
  const [editData, SetEditData] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [openModel, setOpenModel] = useState(false);
  const [deleteCmp, setDeleteCmp] = useState("");
  const [dataId, setDataId] = useState();
  const [pageSize, setPageSize] = useState(15);
  const [rowCount, setRowCount] = useState("");
  const [page, setPage] = useState(0);
  const navigate = useNavigate();
  const { setShowLoginPopup, showLoginPopup } = useAuth();
  const httpService = new HttpService(setShowLoginPopup);
  const [columnName, setColumnName] = useState("");
  const [sortOrder, setsortOrder] = useState("");
  const { company_id, location_id } = useFilter();
  const [openDateModal, setOpenDateModal] = useState(false);
  const dateFilterData = JSON.parse(localStorage.getItem("nutrientsDateFilter"));
  const [startDate, setStartDate] = useState(
    dateFilterData?.startDate
  );
  const [endDate, setEndDate] = useState(
    dateFilterData?.endDate
  );
  const [selectedRadio, setSelectedRadio] = useState(
    dateFilterData?.selectedRadio
  );

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const viewPage = (id) => {
    const urlEncodedId = Encryption(id);
    // Navigate to the encrypted URL
    navigate(`view/${urlEncodedId}`);
  };
  const fetchNutrients = () => {
    setLoading(true);
    let url =  `nutrient/get-nutrient?page=${
          page + 1
        }&pageSize=${pageSize}&search=${searchData}&sortBy=${columnName}&sortOrder=${sortOrder}`
        
      if (startDate !== undefined && startDate !== null && endDate !== undefined && endDate !== null && startDate !== "" && endDate !== "") {
        const formattedStart = dayjs(startDate).format("MM-DD-YYYY");
        const formattedEnd = endDate ? dayjs(endDate).format("MM-DD-YYYY") : dayjs(startDate).format("MM-DD-YYYY");
        url = `${url}&start_date=${formattedStart}&end_date=${formattedEnd}`;
      }
    
    httpService
      .get(
        `${url}`
      )
      .then((response) => {
        if (response?.data?.data) {
          setRows(response?.data?.data);
          // setSearchData(response?.data?.data);
          setRowCount(response?.data?.totalRecords);
          setTimeout(() => {
            setLoading(false);
          }, 300);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching data:", error);
      });
  };
  useEffect(() => {
    fetchNutrients();
  }, [
    company_id,
    location_id,
    showLoginPopup,
    page,
    pageSize,
    searchData,
    columnName,
    sortOrder,
  ]);

  const HandleDeleteNutrients = async () => {
    if (deleteCmp) {
      try {
        const response = await httpService.delete(
          `${"nutrient/delete-nutrient"}/${deleteCmp}`
        );
        fetchNutrients();
        toast.success(response?.message, {
          position: "top-right",
        });
        setOpenModel(false);
      } catch (error) {
        setOpenModel(false);
        console.error("Error deleting employee:", error?.response?.data?.error);
        toast.error(error?.response?.data?.error, {
          position: "top-right",
        });
      }
    }
  };

  const StyledGridOverlay = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    "& .ant-empty-img-1": {
      fill: theme.palette.mode === "light" ? "#aeb8c2" : "#262626",
    },
    "& .ant-empty-img-2": {
      fill: theme.palette.mode === "light" ? "#f5f5f7" : "#595959",
    },
    "& .ant-empty-img-3": {
      fill: theme.palette.mode === "light" ? "#dce0e6" : "#434343",
    },
    "& .ant-empty-img-4": {
      fill: theme.palette.mode === "light" ? "#fff" : "#1c1c1c",
    },
    "& .ant-empty-img-5": {
      fillOpacity: theme.palette.mode === "light" ? "0.8" : "0.08",
      fill: theme.palette.mode === "light" ? "#f5f5f5" : "#fff",
    },
  }));

  function CustomNoRowsOverlay() {
    return (
      <StyledGridOverlay>
        <Box sx={{ mt: 1 }}>No Data Found</Box>
      </StyledGridOverlay>
    );
  }

  const other = {
    showCellVerticalBorder: true,
    showColumnVerticalBorder: true,
  };

  const handleOpenDateTimeModal = () => {
    setOpenDateModal(true);
  };

  const handleDateTimeModal = () => {
    setOpenDateModal(false);
  };

  useEffect(() => {
    const dateFilterData = JSON.parse(
      localStorage.getItem("nutrientsDateFilter")
    );
    if (dateFilterData && dateFilterData?.selectedRadio) {
      setStartDate(dateFilterData?.startDate);
      setEndDate(dateFilterData?.endDate);
      setSelectedRadio(dateFilterData?.selectedRadio);
    } else {
      // const nutrientsDateFilter = {
      //   startDate: dayjs().subtract(6, "day").format("MM-DD-YYYY"),
      //   endDate: dayjs().format("MM-DD-YYYY"),
      //   selectedRadio: "week",
      // };
      // setStartDate(nutrientsDateFilter?.startDate);
      // setEndDate(nutrientsDateFilter?.endDate);
      // setSelectedRadio(nutrientsDateFilter?.selectedRadio);
      // localStorage.setItem(
      //   "nutrientsDateFilter",
      //   JSON.stringify(nutrientsDateFilter)
      // );
    }
  }, []);

  return (
    <>
      {loading && <FullScreenLoader />}
      <div className="company">
        <div className="page-title">
          <div className="title-wrap">
            <h1>Nutrients</h1>
          </div>
          <div className="button-wrap">
          </div>
        </div>
        <div className="table-filter-wrap nutrients-table-filter d-flex justify-content-between">
             <div className="header_search-wrap">
              <div className="header_search_bar common_content">
                <div className="input-group input_group">
                  <button className="btn search-btn search_btn">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      viewBox="0 0 21 21"
                      fill="none"
                    >
                      <circle
                        cx="9.98856"
                        cy="9.98856"
                        r="8.98856"
                        stroke="#495057"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M16.2402 16.7071L19.7643 20.222"
                        stroke="#495057"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                  <input
                    type="search"
                    className="form-control form_control"
                    placeholder="Search..."
                    aria-label="Search"
                    onChange={(e) => {
                      const value = e.target.value;
                      setSearchData(value);
                    }}
                  />
                </div>
              </div>
            </div>
          <div className="d-flex flex-row gap-2">
          <button
              type="submit"
              className="btn btn-primary"
              onClick={() => {
                setOpen(true);
              }}
            >
              <RxPlus /> Add Nutrients
          </button>
          <Button
               variant="outlined"
               color="primary"
               onClick={() => handleOpenDateTimeModal()}
               className="filters-btn"
               style={{ textTransform: "none" }}
             >
               <TbFilterEdit /> Filters
             </Button>

         
          </div>
        </div>

        <div className="nutrients-table"
          style={{
            height: `${rows?.length > 0 ? "" : "200px"}`,
            width: "100%",
            // maxWidth: "830px",
            overflowX: "auto",
          }}
        >
          <DataGrid
            className="company-table"
            slots={{
              noRowsOverlay: CustomNoRowsOverlay,
            }}
            rows={
              rows?.length > 0
                ? rows?.map((row, index) => ({
                    ...row,
                    id: row.id,
                    sequenceNumber: index + 1,
                  }))
                : []
            }
            getRowHeight={() => "auto"}
            sx={{
              [`& .${gridClasses.cell}`]: {
                py: 0.5,
              },
            }}
            columns={[
              {
                field: "action",
                headerName: "Actions",
                headerAlign: "center",
                align: "center",
                width: 90,
                disableColumnMenu: true,
                renderCell: (params) => (
                  <>
                    <div className="action_icon-weap">
                      <IconButton
                        onClick={(e) => {
                          handleMenuClick(e),
                            setDataId(params.row.id),
                            SetEditData(params.row);
                        }}
                      >
                        <GridMoreVertIcon />
                      </IconButton>
                    </div>{" "}
                    {anchorEl && dataId === params?.row?.id && (
                      <Popover
                        className="popup-menu"
                        open={Boolean(anchorEl)}
                        anchorEl={anchorEl}
                        onClose={handleCloseMenu}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "right",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "right",
                        }}
                      >
                        <MenuItem
                          onClick={() => {
                            setOpen(true);
                            setId(dataId);
                            handleCloseMenu();
                          }}
                          className="menu-list-items"
                        >
                          <div className="menu-list-items-text">Edit</div>{" "}
                          <CiEdit style={{ cursor: "pointer" }} />
                        </MenuItem>
                        <MenuItem
                          onClick={() => {
                            setOpenModel(true);
                            setDeleteCmp(dataId);
                            handleCloseMenu();
                          }}
                          className="menu-list-items"
                        >
                          <div className="menu-list-items-text">Delete</div>{" "}
                          <GoTrash style={{ cursor: "pointer" }} />
                        </MenuItem>
                      </Popover>
                    )}
                  </>
                ),
                sortable: false,
              },
              {
                field: "name",
                headerName: "Nutrients Name",
                width: 400,
                flex: 1,
                minWidth: 400,
              },
              {
                field: "unit_name",
                headerName: "Unit",
                width: 120,
                flex: 0.5,
                minWidth: 120,
              },
              {
                field: "is_active",
                headerName: "Status",
                align: "center",
                width: 180,
                flex: 0.8,
                minWidth: 160,
                renderCell: (params) => {
                  const isActive = params?.row?.is_active === true;

                  return (
                    <div
                      className={isActive ? "nutrient-active" : "nutrient-inactive"}
                    >
                      {isActive ? "Active" : "Inactive"}
                    </div>
                  );
                },
                sortable: false,
            }

            ]}
            initialState={{
              pagination: {
                rowCount: -1,
              },
            }}
            onSortModelChange={(e) => {
              if (e && e.length > 0) {
                setsortOrder(e[0].sort);
                setColumnName(e[0].field);
              } else {
                setsortOrder("");
                setColumnName("");
              }
            }}
            paginationMode="server"
            sortingMode="server"
            rowCount={rowCount}
            pageSizeOptions={[15, 50, 100]}
            paginationModel={{ pageSize: pageSize, page: page }}
            onPaginationModelChange={(event) => {
              setPage(event?.page);
              setPageSize(event?.pageSize);
            }}
            checkboxSelection={false}
            rowSelection={false}
            autoHeight
            {...other}
          />
        </div>
      </div>
      {open && (
        <AddEditNutrients
          open={open}
          setOpen={(e) => {
            setOpen(e);
            SetEditData("");
            setId("");
          }}
          id={id}
          editData={editData}
          fetchNutrients={() => fetchNutrients()}
          mode={editData ? "edit" : "add"}
        />
      )}
      {openModel && (
        <DeleteModal
          open={openModel}
          HandleClose={(e) => {
            setOpenModel(e);
            SetEditData("");
          }}
          HandleDelete={() => {
            HandleDeleteNutrients(), SetEditData("");
          }}
        />
      )}
      {openDateModal && (
        <DateTimeModal
          handleDateTimeModal={() => handleDateTimeModal()}
          setStartDate={(e) => setStartDate(e)}
          setEndDate={(e) => setEndDate(e)}
          open={openDateModal}
          fetchSchedule={() => {
            fetchNutrients();
            const nutrientsDateFilter = {
              startDate: startDate,
              endDate: endDate,
              selectedRadio: selectedRadio,
            };
            localStorage.setItem(
              "nutrientsDateFilter",
              JSON.stringify(nutrientsDateFilter)
            );
          }}
          selectedRadio={selectedRadio}
          setSelectedRadio={(e) => setSelectedRadio(e)}
          startDate={startDate}
          endDate={endDate}
        />
      )}
    </>
  );
};
export default Nutrients;
